export default __webpack_public_path__ + "static/FloodplainOrdinances-34844de8b7ec1e23b4ffa41a2c46bb9d.jpg";